import { QueryAPI } from "../api";
import { delay } from "../tools";

export const useDealer = () => {
	//در یافت باندل براساس کیت
	const queryBundleSalesSimByKit = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Bundle/QueryBundleSalesSimByKit", parameters: parameters });
		return response ? response.Result : null;
	};

	const queryBundleSalesSimById = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Bundle/QueryBundleSalesSimById", parameters: parameters });
		return response ? response.Result : null;
	};
	const queryBundleSalesSimByMSISDN = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Bundle/QueryBundleSalesSimByMSISDN", parameters: parameters });
		return response ? response.Result : null;
	};
	// باندل‌های مجاز فروش eSIM
	const queryBundleSalesSimByPlanId = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Bundle/QueryBundleSalesSimByPlanId", parameters: parameters });
		return response ? response.Result : null;
	};
	// پرداخت فروش eSIM؛ silent تا خطای 1126 (کسری کیف پول، با result.shortageAmount) را خود صفحه مدیریت کند
	const redirectToNeginWalletGateWayEsim = async (parameters) => {
		return await QueryAPI({ url: "/dealer/PaymentInfo/RedirectToNeginWalletGateWay", parameters: parameters, silent: true });
	};
	const queryMSISDNByBundleSalesSimId = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/MSISDN/QueryMSISDNByBundleSalesSimId", parameters: parameters });
		return response ? response : null;
	};
	const validateKitNo = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/ICCID/ValidateKitNo", parameters: parameters });
		return response ? response.Result : null;
	};
	const reserveKitNo = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/ICCID/ReserveKitNo", parameters: parameters });
		return response ? response : null;
	};
	const reserveMSISDN = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/MSISDN/ReserveMSISDN", parameters: parameters });
		return response ? response : null;
	};
	// دریافت پروفایل براساس کد ملی و تاریخ تولد
	const queryProfileByCertNoVBirthDate = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/IdentityInformation/QueryProfileByCertNoVBirthDate", parameters: parameters });
		return response ? response.Result : null;
	};
	// دریافت تعداد سیم کارت فعال
	const queryCountSimCardByCertNo = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/IdentityInformation/QueryCountSimCardByCertNo", parameters: parameters });
		return response ? response.Result : null;
	};
	//دریافت اطلاعات پستی
	const addressByPostcode = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/IdentityInformation/AddressByPostcode", parameters: parameters });
		return response ? response.Result : null;
	};
	// ارسال پروفایل مشترک
	const addProfile = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/IdentityInformation/AddProfile", parameters: parameters });
		return response ? response.Result : null;
	};
	//ارسال آدرس پروفایل
	const addAddress = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/IdentityInformation/AddAddress", parameters: parameters });
		return response ? response : null;
	};
	//روش ارسال سیم کارت
	const queryMethodOfReceiptByPlanId = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/PaymentInfo/QueryMethodOfReceiptByPlanId", parameters: parameters });
		return response ? response.Result : null;
	};
	//دریافت کمیسیون تعویض سیم کارت
	const calculateSWCommissionPrice = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/PaymentInfo/CalculateSWCommissionPrice", parameters: parameters });
		return response ? response.Result : null;
	};
	//محاسبه کمیسیون
	const calculateSPCommissionPrice = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/PaymentInfo/CalculateSPCommissionPrice", parameters: parameters });
		return response ? response.Result : null;
	};
	//بررسی صحیح بودن کد تخفیف
	const isValidDiscountCode = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Discount/IsValidDiscountCode", parameters: parameters });
		return response ? response : null;
	};
	//دریافت کد تخفیف
	const queryDiscountCodeByCode = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Discount/QueryDiscountCodeByCode", parameters: parameters });
		return response ? response.Result : null;
	};

	//فعال سازی سیم کارت
	const redirectToNeginWalletGateWay = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/PaymentInfo/RedirectToNeginWalletGateWay", parameters: parameters });
		return response ? response.Result : null;
	};
	//اپلود سند خرید سیم کارت
	const updateDocumentSPPurchase = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Document/UpdateDocumentSPPurchase", parameters: parameters });
		return response ? response : null;
	};
	//اپلود سند خرید سیم کارت
	const updateDocumentSPPurchaseWithAddDoc = async (parameters, doctype, sppurchaseid) => {
		let response = null;
		response = await QueryAPI({
			url: `/dealer/Document/UpdateDocumentSPPurchaseWithAddDoc?doctype=${doctype}&sppurchaseid=${sppurchaseid}`,
			parameters: parameters,
			contentType: "multipart/form-data",
		});
		return response ? response : null;
	};
	//بررسی کیت برای تعویض
	const checkKitNOForSW = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/ICCID/CheckKitNOForSW", parameters: parameters });
		return response ? response : null;
	};

	//دریافت پیش فاکتور تعویض
	const sWPreFactor = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/PaymentInfo/SWPreFactor", parameters: parameters });
		return response ? response.Result : null;
	};

	//تعویض سیم کارت
	const simSwap = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/CompletePurchase/SimSwap", parameters: parameters });
		return response ? response.Result : null;
	};

	//لیست مقادیر شارژ
	const queryValidChargeByPlanId = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Product/QueryValidChargeByPlanId", parameters: parameters });
		return response ? response.Result : null;
	};
	//بررسی شماره برای خرید شارژ
	const isValidMSISDNToBuyCharge = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Subscription/IsValidMSISDNToBuyCharge", parameters: parameters });
		return response ? response.Result : null;
	};

	const isValidMSISDNToChangeOwner = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Subscription/IsValidMSISDNToChangeOwner", parameters: parameters });
		return response ? response : null;
	};
	const completeDCPurchase = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/PaymentInfo/CompleteDCPurchase", parameters: parameters });
		return response ? response.Result : null;
	};

	//دریافت لیست بسته ها از طریق شماره
	const queryPackage = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Product/QueryPackage", parameters: parameters });
		return response ? response.Result : null;
	};
	//دریافت گروه های فیلتر بسته ها
	const queryProductGroup = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Product/QueryProductGroup", parameters: parameters });
		return response ? response.Result : null;
	};
	//دریافت بسته ها براساس گروه بندی
	const queryPackagesBySubGroup = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Product/QueryPackagesBySubGroup", parameters: parameters });
		return response ? response.Result : null;
	};
	//سرویس خرید و فعالسازی بسته
	const completeEPPurchase = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/PaymentInfo/CompleteEPPurchase", parameters: parameters });
		return response ? response.Result : null;
	};

	//لیست مدارک ارسال نشده خرید سیم کارت
	const querySPPurchaseDealerByState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/QuerySPPurchaseDealerByState", parameters: parameters });
		return response ? response : null;
	};

	//دریافت وضعیت خرید سیم کارت
	const queryLogChangeStatePurchase = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Reports/QueryLogChangeStatePurchase?id=${parameters}`, type: "get" });
		return response ? response.Result : null;
	};

	//دریافت جزییات خرید و پروفایل
	const querySPPurchaseVProfileDealerById = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Subscription/QuerySPPurchaseVProfileDealerById?sppurchaseid=${parameters}`, type: "get" });
		return response ? response.Result : null;
	};

	//دریافت لیست تحویل سیم کارت فرودگاه
	const querySPPurchaseByMethodOfReceipt = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Subscription/QuerySPPurchaseByMethodOfReceipt`, parameters: parameters });
		return response ? response?.Result?.Result : null;
	};

	//دریافت لیست تحویل سیم کارت فرودگاه
	const querySPPurchaseByMethodOfReceiptList = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Subscription/QuerySPPurchaseByMethodOfReceiptList`, parameters: parameters });
		return response ? response?.Result?.Result : null;
	};

	//دریافت اطلاعات پیش فاکتور تغییر مالکیت
	const changeOwnerPreFactor = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/PaymentInfo/ChangeOwnerPreFactor`, parameters: parameters });
		return response ? response?.Result : null;
	};
	//تغییر مالکیت سیم کارت
	const changeOwner = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/CompletePurchase/ChangeOwner`, parameters: parameters });
		return response ? response?.Result : null;
	};

	//تغییر مالکیت حقوقی
	const changeOwnerB2B = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/CompletePurchase/ChangeOwnerB2B`, parameters: parameters });
		return response ? response?.Result : null;
	};

	//لیست جستجوی کیف پول
	const queryWalletByDate = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Reports/QueryWalletByDate`, parameters: parameters });
		return response ? response : null;
	};

	//بررسی امکان تعویض سیم کارت
	const isValidMSISDNToSimSwap = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Subscription/IsValidMSISDNToSimSwap`, parameters: parameters });
		return response ? response : null;
	};

	//ارسال پروفایل به همراه فایل تصویر کارت شناسایی
	const addProfileWithDoc = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/IdentityInformation/AddProfileWithDoc`, parameters: parameters, contentType: "multipart/form-data" });
		return response ? response?.Result : null;
	};

	//اپدیت مدرک پروفایل مشترک
	const updateDocumentProfile = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/IdentityInformation/UpdateDocumentProfile`, parameters: parameters });
		return response ? response : null;
	};

	//اپدیت مدرک پروفایل مشترک
	const updateDocumentSPPurchaseVProfile = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Document/UpdateDocumentSPPurchaseVProfile`, parameters: parameters });
		return response ? response : null;
	};

	//گزارش فروش
	const querySPPurchaseDealerByDate = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Reports/QuerySPPurchaseDealerByDate`, parameters: parameters });
		return response ? response : null;
	};
	//گزارش تغییر مالکیت
	const queryCoPurchaseDealerByDate = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Reports/QueryCoPurchaseDealerByDate`, parameters: parameters });
		return response ? response : null;
	};
	//گزارش تعویض سیم کارت
	const querySWPurchaseDealerByDate = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Reports/QuerySWPurchaseDealerByDate`, parameters: parameters });
		return response ? response : null;
	};
	//گزارش فروش شارژ
	const queryDCPurchaseDealerByDate = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Reports/QueryDCPurchaseDealerByDate`, parameters: parameters });
		return response ? response : null;
	};
	//گزارش فروش بسته
	const queryEPPurchaseDealerByDate = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Reports/QueryEPPurchaseDealerByDate`, parameters: parameters });
		return response ? response : null;
	};
	//درانتظار آپلود مدارک تغییرمالکیت
	const queryCOPurchaseDealerByState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Reports/QueryCOPurchaseDealerByState`, parameters: parameters });
		return response ? response : null;
	};
	//اپدیت مدارک تغییرمالکیت
	const updateDocumentCOPurchase = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Document/UpdateDocumentCOPurchase`, parameters: parameters });
		return response ? response : null;
	};
	//درانتظار آپلود مدارک تعویض سیمکارت
	const querySWPurchaseDealerByState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Reports/QuerySWPurchaseDealerByState`, parameters: parameters });
		return response ? response : null;
	};
	//اپدیت مدارک تعویض سیمکارت
	const updateDocumentSWPurchase = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Document/UpdateDocumentSWPurchase`, parameters: parameters });
		return response ? response : null;
	};

	//لیست گروه های اطلاع رسانی
	const queryAnnouncementGroupByPlanId = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Message/QueryAnnouncementGroupByPlanId`, parameters: parameters });
		return response ? response?.Result : null;
	};
	//لیست گروه های اطلاع رسانی
	const queryAnnouncementDealerByState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Message/QueryAnnouncementDealerByState`, parameters: parameters });
		return response ? response : null;
	};

	//علامت خواندن برای notification
	const createAnnouncementsVUser = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Message/CreateAnnouncementsVUser`, parameters: parameters });
		return response ? response?.Result : null;
	};
	//جزییات شارژ کیف پول
	const queryDetailOfChangeWallet = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Reports/QueryDetailOfChangeWallet`, parameters: parameters });
		return response ? response?.Result : null;
	};
	//تغییر سیم کارت
	const updateDocumentSWPurchaseVProfile = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Document/UpdateDocumentSWPurchaseVProfile`, parameters: parameters });
		return response ? response : null;
	};

	//کمیسیون تغییرمالکیت
	const calculateCOCommissionPrice = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/PaymentInfo/CalculateCOCommissionPrice`, parameters: parameters });
		return response ? response?.Result : null;
	};

	//1)چک کردن مطابقت شماره موایل و کد ملی در حداول خودمون
	const validateMSISDNVCertNO = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/IdentityInformation/ValidateMSISDNVCertNO`, parameters: parameters });
		return response ? response : null;
	};

	const queryCountActiveSPPurchaseByCertNo = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/IdentityInformation/QueryCountActiveSPPurchaseByCertNo`, parameters: parameters });
		return response ? response?.Result : null;
	};

	const queryActiveSPPurchaseByCertNoVMSISDN = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Subscription/QueryActiveSPPurchaseByCertNoVMSISDN`, parameters: parameters });
		return response ? response : null;
	};

	const queryIMEI = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Subscription/QueryIMEI`, parameters: parameters });
		return response ? response?.Result : null;
	};

	const queryLACByMSISDN = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/crm/Subscription/QueryLACByMSISDN?msisdn=${parameters}`, type: "get" });
		return response ? response?.Result : null;
	};

	const queryMSISDNVICCIDBySPPurchaseId = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Subscription/QueryMSISDNVICCIDBySPPurchaseId?sppurchaseid=${parameters}`, parameters, type: "get" });
		return response ? response?.Result : null;
	};
	const querySPPurchaseBySPPurchaseId = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Subscription/QuerySPPurchaseBySPPurchaseId?sppurchaseid=${parameters}`, parameters, type: "get" });
		return response ? response?.Result : null;
	};
	const queryProfileSPurchaseBySPPurchaseId = async (parameters) => {
		let response = null;
		response = await QueryAPI({
			url: `/dealer/Subscription/QueryProfileSPurchaseBySPPurchaseId?sppurchaseid=${parameters}`,
			parameters,
			type: "get",
		});
		return response ? response?.Result : null;
	};

	const queryActivatedProductsMSISDN = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Subscription/QueryActivatedProductsMSISDN?msisdn=${parameters}`, parameters, type: "get" });
		return response ? response?.Result : null;
	};

	const queryDCPurchaseBySPPurchaseId = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Reports/QueryDCPurchaseBySPPurchaseId`, parameters: parameters });
		return response ? response : null;
	};

	const queryEPPurchaseBySPPurchaseId = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Reports/QueryEPPurchaseBySPPurchaseId`, parameters: parameters });
		return response ? response : null;
	};

	const querySWPurchaseBySPPurchaseId = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Reports/QuerySWPurchaseBySPPurchaseId`, parameters: parameters });
		return response ? response : null;
	};

	//سهم از فروش
	const queryRevenueShareByDate = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Reports/QueryRevenueShareByDate`, parameters: parameters });
		return response ? response : null;
	};

	const queryBalance = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Subscription/QueryBalance?msisdn=${parameters}`, type: "get" });
		return response ? response?.Result : null;
	};
	const queryFirstActivationDate = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Subscription/QueryFirstActivationDate?msisdn=${parameters}`, type: "get" });
		return response ? response?.Result : null;
	};

	const queryHotBill = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Billing/QueryHotBill`, parameters: parameters });
		return response ? response?.Result : null;
	};

	const callBackBillingToNeginWallet = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Billing/CallBackBillingToNeginWallet`, parameters: parameters });
		return response ? response?.Result : null;
	};
	const queryMSCAddress = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Subscription/QueryMSCAddress`, parameters: parameters });
		return response ? response?.Result : null;
	};
	const updateMobileNetwork = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Subscription/UpdateMobileNetwork`, parameters: parameters });
		return response ? response : null;
	};

	const queryBankCardProfileByCertNo = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/BankCard/IdentityInformation/QueryBankCardProfileByCertNo?certno=${parameters}`, type: "get" });
		return response ? response : null;
	};
	const queryBankCardProfileByPassportNo = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/BankCard/IdentityInformation/QueryBankCardProfileByPassportNo?passportno=${parameters}`, type: "get" });
		return response ? response : null;
	};

	const queryBankCardProfileByEmail = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/BankCard/IdentityInformation/QueryBankCardProfileByEmail?email=${parameters}`, type: "get" });
		return response ? response : null;
	};
	const queryBankCardProvider = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/public/BaseInfo/QueryBankCardProvider`, type: "get" });
		return response ? response?.Result : null;
	};
	const registerBankCardProfile = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/BankCard/IdentityInformation/RegisterBankCardProfile`, parameters: parameters });
		return response ? response : null;
	};

	const assignCardToCustomer = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/BankCard/CardAssignment/AssignCardToCustomer`, parameters: parameters });
		return response ? response : null;
	};
	const changeMSISDNStatus = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/Subscription/ChangeMSISDNStatus`, parameters: parameters });
		return response ? response : null;
	};
	const uploadBankCardProfileFile = async (docType, profileid, parameters) => {
		let response = null;
		response = await QueryAPI({
			url: `/dealer/BankCard/Document/UploadBankCardProfileFile?doctype=${docType}&profileid=${profileid}`,
			parameters,
			contentType: "multipart/form-data",
		});
		await delay();
		return response ? response : null;
	};
	const uploadBankCardContractFile = async (docType, profileid, parameters) => {
		let response = null;
		response = await QueryAPI({
			url: `/dealer/BankCard/Document/UploadBankCardContractFile?doctype=${docType}&profileid=${profileid}`,
			parameters,
			contentType: "multipart/form-data",
		});
		await delay();
		return response ? response : null;
	};

	const convertDCFileToJson = async (request) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/FileManager/ConvertDCFileToJson", parameters: request, contentType: "multipart/form-data" });
		return response ? response?.Result : null;
	};

	const queryAssignedKit = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/ICCID/QueryAssignedKit`, parameters: parameters });
		return response ? response : null;
	};

	const queryMyKits = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/ICCID/QueryMyKits`, parameters: parameters });
		return response ? response : null;
	};

	const queryRegisterKitRequestDistributer = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/ICCID/QueryRegisterKitRequestDistributer`, parameters: parameters });
		return response ? response : null;
	};
	const queryRegisterKitRequest = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/ICCID/QueryRegisterKitRequest`, parameters: parameters });
		return response ? response : null;
	};

	const registerKitRequest = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/ICCID/RegisterKitRequest`, parameters: parameters });
		return response ? response : null;
	};
	const queryDealerPoolMapping = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/ICCID/QueryDealerPoolMapping`, parameters: parameters });
		return response ? response.Result : null;
	};
	const queryDealerKitLimits = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/ICCID/QueryDealerKitLimits`, parameters: parameters });
		return response ? response.Result : null;
	};

	const queryKitAssignedToUser = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/ICCID/QueryKitAssignedToUser`, parameters: parameters });
		return response ? response.Result : null;
	};
	const queryKitAssignedToUserWithPagination = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/ICCID/QueryKitAssignedToUserWithPagination`, parameters: parameters });
		return response ? response : null;
	};

	const queryDealerPoolStock = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/ICCID/QueryDealerPoolStock`, parameters: parameters });
		return response ? response : null;
	};

	const assignKitToDealer = async (parameters, options) => {
		let response = null;
		response = await QueryAPI({ url: `/dealer/ICCID/AssignKitToDealer`, parameters: parameters, silent: options?.silent });
		return response ? response : null;
	};

	return {
		queryBundleSalesSimByKit,
		queryBundleSalesSimByPlanId,
		redirectToNeginWalletGateWayEsim,
		queryBundleSalesSimById,
		queryBundleSalesSimByMSISDN,
		queryMSISDNByBundleSalesSimId,
		validateKitNo,
		reserveKitNo,
		reserveMSISDN,
		queryProfileByCertNoVBirthDate,
		queryCountSimCardByCertNo,
		addressByPostcode,
		addProfile,
		addAddress,
		queryMethodOfReceiptByPlanId,
		calculateSWCommissionPrice,
		calculateSPCommissionPrice,
		isValidDiscountCode,
		queryDiscountCodeByCode,
		redirectToNeginWalletGateWay,
		updateDocumentSPPurchase,
		updateDocumentSPPurchaseWithAddDoc,
		checkKitNOForSW,
		sWPreFactor,
		simSwap,
		queryValidChargeByPlanId,
		isValidMSISDNToBuyCharge,
		completeDCPurchase,
		queryPackage,
		queryProductGroup,
		queryPackagesBySubGroup,
		completeEPPurchase,
		querySPPurchaseDealerByState,
		queryLogChangeStatePurchase,
		querySPPurchaseVProfileDealerById,
		querySPPurchaseByMethodOfReceipt,
		changeOwnerPreFactor,
		changeOwner,
		changeOwnerB2B,
		queryWalletByDate,
		isValidMSISDNToSimSwap,
		addProfileWithDoc,
		querySPPurchaseDealerByDate,
		updateDocumentProfile,
		updateDocumentSPPurchaseVProfile,
		queryCoPurchaseDealerByDate,
		querySWPurchaseDealerByDate,
		queryDCPurchaseDealerByDate,
		queryEPPurchaseDealerByDate,
		queryCOPurchaseDealerByState,
		updateDocumentCOPurchase,
		querySWPurchaseDealerByState,
		updateDocumentSWPurchase,
		queryAnnouncementGroupByPlanId,
		queryAnnouncementDealerByState,
		queryDetailOfChangeWallet,
		updateDocumentSWPurchaseVProfile,
		calculateCOCommissionPrice,
		createAnnouncementsVUser,
		querySPPurchaseByMethodOfReceiptList,
		validateMSISDNVCertNO,
		queryCountActiveSPPurchaseByCertNo,
		queryActiveSPPurchaseByCertNoVMSISDN,
		queryMSISDNVICCIDBySPPurchaseId,
		querySPPurchaseBySPPurchaseId,
		queryProfileSPurchaseBySPPurchaseId,
		queryActivatedProductsMSISDN,
		queryDCPurchaseBySPPurchaseId,
		queryEPPurchaseBySPPurchaseId,
		querySWPurchaseBySPPurchaseId,
		queryRevenueShareByDate,
		queryBalance,
		queryFirstActivationDate,
		isValidMSISDNToChangeOwner,
		queryHotBill,
		callBackBillingToNeginWallet,
		queryMSCAddress,
		updateMobileNetwork,
		queryBankCardProfileByCertNo,
		queryBankCardProfileByPassportNo,
		queryBankCardProfileByEmail,
		queryIMEI,
		queryLACByMSISDN,
		registerBankCardProfile,
		uploadBankCardProfileFile,
		uploadBankCardContractFile,
		queryBankCardProvider,
		assignCardToCustomer,
		changeMSISDNStatus,
		convertDCFileToJson,
		queryAssignedKit,
		queryMyKits,
		queryRegisterKitRequestDistributer,
		queryRegisterKitRequest,
		registerKitRequest,
		queryDealerPoolMapping,
		queryDealerKitLimits,
		queryKitAssignedToUser,
		queryKitAssignedToUserWithPagination,
		queryDealerPoolStock,
		assignKitToDealer,
	};
};
